module.exports = __webpack_public_path__ + "img/Under 16 Icon - white.4ccaf0cf.svg";